import { LocalizedAttribute } from '_stores/common.types'
import APP from '_constants/app'

export const buildLocalizedObject = (value: any): LocalizedAttribute<any> => {
  return APP.languagues.reduce((localizedObject, language: string) => {
    localizedObject[language] = value
    return localizedObject as LocalizedAttribute<any>
  }, {}) as LocalizedAttribute<any>
}
